import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { NAV_LINKS, IMAGES } from '../data/site';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const solid = scrolled || open;
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${solid ? 'bg-white/90 backdrop-blur-xl border-b border-black/5 shadow-soft' : 'bg-transparent border-b border-transparent'}`} data-id="element-144" data-mp="31byx5464pxnh">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-5 sm:px-8 h-20 lg:h-24" data-id="element-145" data-mp="3bbpr94qs2an1">
        <a href="#inicio" className="flex items-center gap-3 shrink-0" aria-label="Silver Hogar - Inicio" data-id="element-146" data-mp="3fbzsy57jeew3">
          <span className="inline-flex h-12 w-12 lg:h-14 lg:w-14 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white shadow-soft" data-id="element-147" data-mp="2rl8cateegj1p">
            <img src={IMAGES.logo} alt="Silver Hogar" className="h-full w-full object-contain p-1" data-id="element-148" data-mp="2mmwyk7kzhoe7" />
          </span>
          <span className="flex flex-col leading-none" data-id="element-149" data-mp="3fa0yvz94tejn">
            <span className={`text-base lg:text-lg font-semibold tracking-tight transition-colors duration-500 ${solid ? 'text-ink' : 'text-white'}`} data-id="element-150" data-mp="3ac9b9hfisel9">
              Silver <span className="text-brand" data-id="element-151" data-mp="30mzcjiq67xo6">Hogar</span>
            </span>
            <span className={`mt-1 text-[10px] tracking-[0.2em] uppercase transition-colors duration-500 ${solid ? 'text-ink-muted' : 'text-white/70'}`} data-id="element-152" data-mp="1wfq2pa8uexv">
              Muebles · Electrodomésticos
            </span>
          </span>
        </a>

        <nav className="hidden xl:flex items-center gap-8" aria-label="Navegación principal" data-id="element-153" data-mp="1wco6tvzhne4u">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} className={`group relative text-sm font-medium transition-colors duration-300 ${solid ? 'text-ink-soft hover:text-ink' : 'text-white/85 hover:text-white'}`} data-id="element-154" data-mp="1hmqf562co6aw">
              {link.label}
              <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-brand transition-all duration-300 group-hover:w-full" data-id="element-155" data-mp="1cq8eoie1yu4d" />
            </a>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-156" data-mp="13n77sfhd4yzn">
          <a href="#contacto" className="hidden sm:inline-flex items-center rounded-full bg-brand px-6 py-3 text-sm font-medium text-white transition-all duration-300 hover:bg-brand-dark hover:shadow-float focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" data-id="element-157" data-mp="13q3644x4hpom">
            Hablemos
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className={`xl:hidden inline-flex h-11 w-11 items-center justify-center rounded-full border transition-colors duration-300 ${solid ? 'border-black/10 text-ink' : 'border-white/30 text-white'}`} data-id="element-158" data-mp="hgwcu7xpzng6">
            {open ? <XIcon className="h-5 w-5" data-id="element-159" data-mp="108feaac3itg3" /> : <MenuIcon className="h-5 w-5" data-id="element-160" data-mp="1f3vc8qfsr9hr" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-161" data-mp="1a4ij5nyc166q">
        {open && <motion.nav key="mobile-nav" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.35,
        ease: [0.22, 1, 0.36, 1]
      }} className="xl:hidden overflow-hidden border-t border-black/5 bg-white" aria-label="Navegación móvil" data-id="element-162" data-mp="1a4s775zth39s">
            <div className="px-5 sm:px-8 py-6 flex flex-col gap-1" data-id="element-163" data-mp="27vx98x9c8z00">
              {NAV_LINKS.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="rounded-2xl px-4 py-3 text-base font-medium text-ink-soft transition-colors hover:bg-haze hover:text-ink" data-id="element-164" data-mp="2cuqnwt0d2w1r">
                  {link.label}
                </a>)}
              <a href="#contacto" onClick={() => setOpen(false)} className="mt-3 inline-flex justify-center rounded-full bg-brand px-6 py-3.5 text-sm font-medium text-white transition-colors hover:bg-brand-dark" data-id="element-165" data-mp="1t7t12n7ww5vh">
                Hablemos
              </a>
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}